import styled from 'styled-components';
import { CSSVars } from '../../styles/styles.config';

export const StyledWidgetDiv = styled.div`
	background-color: ${CSSVars.white};
	color: ${CSSVars.black};
	max-width: 1420px;
	margin: 0 auto;
	padding: 30px;

	@media screen and (min-width: ${CSSVars.breakpointLG}) {
		padding: 50px 120px;
	}

	@media screen and (min-width: ${CSSVars.breakpoint2XL}) {
		border-radius: 10px;
		border: 2px solid ${CSSVars.gray50};
	}

	h2 {
		font-size: ${CSSVars.fontSize2XL};
	}

	.p {
		font-size: ${CSSVars.fontSizeMD};
		font-weight: 300;
		margin-top: 30px;

		@media screen and (min-width: ${CSSVars.breakpointMD}) {
			font-size: ${CSSVars.fontSizeLG};
		}
	}

	.platform-link-wrapper {
		margin-top: 30px;
		display: flex;
		align-items: center;
		gap: 5px;
		font-size: ${CSSVars.fontSizeMD};
		font-weight: 300;

		@media screen and (min-width: ${CSSVars.breakpointMD}) {
			font-size: ${CSSVars.fontSizeLG};
		}
	}
`;
